import { render } from "./ClientInvoiceBuyerModal.vue?vue&type=template&id=6e07cd56&scoped=true"
import script from "./ClientInvoiceBuyerModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ClientInvoiceBuyerModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./ClientInvoiceBuyerModal.vue?vue&type=style&index=0&id=6e07cd56&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e07cd56"]])

export default __exports__